import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material"
import { useTranslation } from "react-i18next"

import { type TelemetryFieldDef } from "helpers/config/telemetryFieldDefs"
import { getTelemetryTranslation } from "helpers/utils/translations"

interface TelemetryTableProps {
  fields: Record<string, TelemetryFieldDef>
}

export default function TelemetryTable({ fields }: TelemetryTableProps) {
  const { t } = useTranslation()
  const hasMeasurement = Object.values(fields).some((def) => def.measurement)

  return (
    <TableContainer
      component={Paper}
      sx={{ py: 1, mb: 2, "&.MuiPaper-root": { boxShadow: "none" } }}
    >
      <Table sx={{ minWidth: 650 }} size="small">
        <TableBody>
          <TableRow>
            <TableCell sx={{ width: "30%" }}>
              <b>{t("api.TELEMETRY_TABLE.name")}</b>
            </TableCell>
            <TableCell sx={{ width: hasMeasurement ? "35%" : "55%" }}>
              <b>field</b>
            </TableCell>
            {hasMeasurement && (
              <TableCell sx={{ width: "20%" }}>
                <b>measurement</b>
              </TableCell>
            )}
            <TableCell sx={{ width: "15%" }}>
              <b>{t("api.TELEMETRY_TABLE.unit")}</b>
            </TableCell>
          </TableRow>
          {Object.entries(fields).map(([field, def]) => (
            <TableRow key={field}>
              <TableCell>{getTelemetryTranslation(field, t)}</TableCell>
              <TableCell>{field}</TableCell>
              {hasMeasurement && <TableCell>{def.measurement ?? ""}</TableCell>}
              <TableCell>{def.unit}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
